// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const PaginationBannerPlay: React.FC<{ width?: number; height?: number; color1?: string; className?: string }> = ({
    width = undefined,
    height = undefined,
    color1 = "#577538",
    className,
}) => {
    return (
        <svg className={className} focusable="false" viewBox="0 0 12 14" width={width} height={height}>
            <path
                fill="currentColor"
                d="M1.76 1.072a.5.5 0 0 0-.507-.01.5.5 0 0 0-.256.438v11a.502.502 0 0 0 .762.428l9-5.5a.5.5 0 0 0 0-.856zM.765.19A1.5 1.5 0 0 1 2.28.219l9 5.5a1.5 1.5 0 0 1 0 2.563l-9 5.5a1.5 1.5 0 0 1-1.515.027A1.5 1.5 0 0 1 0 12.5v-11C0 .956.294.456.766.19"
            />
        </svg>
    );
};

export default React.memo(PaginationBannerPlay);
